export const container = `w-full`;
export const title = `text-xs text-gray-800 mb-1`;
export const subcategories = `flex flex-wrap gap-1 mb-4`;
export const button = `
  flex items-center gap-x-1 text-nowrap
  py-1.5 px-2.5 rounded-full text-sm font-medium transition-colors
  border border-gray-150 text-gray-400 bg-base-white

  hover:bg-gray-400
  hover:text-base-white
  hover:border-gray-400

  data-[is-active=true]:bg-gray-400
  data-[is-active=true]:text-base-white
  data-[is-active=true]:border-gray-400
`;
